export default {
  setOktaUser: (state, oktaUser) => {
    state.oktaUser = oktaUser
  },
  setOktaUserHistory: (state, oktaUserHistory) => {
    state.oktaUserHistory = oktaUserHistory
  }

}
